/**
 * @generated SignedSource<<cf482904d2b55e7e7828af478c25500f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FavoritesItem_item$data = {
  readonly isAuctionEnabled: boolean | null;
  readonly isSponsored: boolean | null;
  readonly serviceId: string | null;
  readonly title: string | null;
  readonly " $fragmentType": "FavoritesItem_item";
};
export type FavoritesItem_item$key = {
  readonly " $data"?: FavoritesItem_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"FavoritesItem_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FavoritesItem_item",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isAuctionEnabled",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isSponsored",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "2cbcc7667ea0834b52bbd5e5059a7817";

export default node;
